import React from 'react';

import ConfirmDialog from 'APP_ROOT/components/common/ConfirmDialog';
import SimpleProfileImage from 'APP_ROOT/components/SimpleProfileImage';

export default class DeleteDialog extends React.Component {

    render() {

        const {
            isOpen,
            onOk,
            onCancel,
            onDismiss,
            selectedFaces,
        } = this.props;

        return (
            <ConfirmDialog
                isOpen={isOpen}
                contentLabel="delete-selected-faces"
                onOk={onOk}
                onCancel={onCancel}
                onDismiss={onDismiss}>

                <div className="row">
                    <div className="col"><h1>{ selectedFaces.length === 1 ? 'Delete Selected Face?' : 'Delete Selected Faces?' }</h1></div>
                </div>
                <div className="row">
                    <div className="alert alert-danger" role="alert">
                        { selectedFaces.length === 1 ? 'You are about to delete this face.' : 'You are about to delete these faces.'  } This action cannot be undone. Click OK to proceed.
                    </div>
                </div>
                <div className="row justify-content-center">
                    {selectedFaces.map(face => {
                        return (
                            <div className="col-auto text-center" key={face.identityId}>
                                <SimpleProfileImage.Small src={face.profileImageUrl} />
                                {face.name}
                            </div>
                        );
                    })}
                </div>
            </ConfirmDialog>
        );
    }
}
